import React, { useEffect, useState } from "react";
import "../css/Changelog.css";
import axios from "axios";
import { GoldLoader } from "../shared/Loaders";

const formatValue = (val) => {
  if (val === null || val === undefined || val === "") return "-";
  if (typeof val === "object") return JSON.stringify(val);
  return String(val);
};

const entitySummary = (log) => {
  if (log.entity_label) return log.entity_label;
  if (log.edited_participant_id) {
    const person = log.edited_person_id;
    const name = person
      ? [person.name, person.lname].filter(Boolean).join(" ")
      : "";
    return name ? `Participant: ${name}` : "Participant";
  }
  if (log.edited_form_id?.form_name) return `Form: ${log.edited_form_id.form_name}`;
  if (log.edited_group_id?.group_name) return `Group: ${log.edited_group_id.group_name}`;
  if (log.edited_template_id?.name) return `Template: ${log.edited_template_id.name}`;
  if (log.edited_competition_id?.title || log.edited_competition_id?.name) {
    return `Competition: ${log.edited_competition_id.title || log.edited_competition_id.name}`;
  }
  return "-";
};

const ChangeLog = () => {
  const [changelogs, setChangelogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    axios
      .get(`${API_URL}/changelogs?module=ems`)
      .then((res) => {
        const data = res.data || [];
        setChangelogs(Array.isArray(data) ? data : []);
      })
      .catch((err) => console.error("Failed to fetch EMS changelogs", err))
      .finally(() => setLoading(false));
  }, [API_URL]);

  if (loading) {
    return <GoldLoader label="Loading..." variant="page" />;
  }

  return (
    <div className="changelog-wrapper ems-changelog-page ems-list-toolbar">
      <div className="changelog-table-container">
        <table className="igf-changelog-table">
          <thead>
            <tr>
              <th>Entity</th>
              <th>Competition</th>
              <th>Updated On</th>
              <th>Updated By</th>
              <th>Field</th>
              <th>Previous</th>
              <th>New</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="7">
                  <GoldLoader label="Loading..." variant="section" />
                </td>
              </tr>
            ) : changelogs.length > 0 ? (
              changelogs.map((log, index) => (
                <tr key={log._id || index}>
                  <td>{entitySummary(log)}</td>
                  <td>
                    {log.edited_competition_id?.title ||
                      log.edited_competition_id?.name ||
                      "-"}
                  </td>
                  <td>
                    {log.updated_on
                      ? new Date(log.updated_on).toLocaleString()
                      : "-"}
                  </td>
                  <td>
                    {log.edited_by_admin?.username ||
                      [log.edited_by_person?.name, log.edited_by_person?.lname]
                        .filter(Boolean)
                        .join(" ")
                        .trim() ||
                      log.edited_by_person?.email ||
                      "-"}
                  </td>
                  <td className="field-name">{log.field || "-"}</td>
                  <td className="value-cell">{formatValue(log.prev_value)}</td>
                  <td className="value-cell">{formatValue(log.new_value)}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="no-data">
                  No EMS changelog data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ChangeLog;
